import React, { useContext } from 'react';
import { AuthContext } from '../contexts/AuthContext';
import { Navigate } from 'react-router-dom';

export default function ProtectedRoute({ children }) {
  const { auth } = useContext(AuthContext);

  if (!auth.token) {
    // Benutzer ist nicht authentifiziert
    return <Navigate to="/login" replace />;
  }

  // Benutzer ist authentifiziert
  return children;
}
